<div class="content">
    <nirby-card-view
        [card]="card"
        [context]="context"
        (loaded)="loaded.emit()"
    ></nirby-card-view>
</div>
